import { Link } from 'react-router-dom';
import SectionHeading from '@/components/base/SectionHeading';
import { brand, testimonials } from '@/mocks/gossip';

export default function BrandVoiceSection() {
  return (
    <section id="voice" className="w-full px-4 md:px-8 py-14 md:py-20 bg-background-100">
      <div className="grid grid-cols-1 lg:grid-cols-2 gap-10 items-center">
        <div className="w-full h-72 md:h-96 rounded-lg overflow-hidden">
          <img
            src="https://readdy.ai/api/search-image?query=stylized%20warm%20community%20gathering%20abstract%20scene%20with%20coral%20amber%20and%20mint%20green%20shapes%2C%20friendly%20editorial%20illustration%2C%20soft%20natural%20light%2C%20no%20text&width=1000&height=800&seq=gt-brand-community&orientation=landscape"
            alt="瓜田福利社 社区交流氛围图"
            title="瓜田福利社 社区"
            className="w-full h-full object-cover object-top"
          />
        </div>
        <div>
          <SectionHeading
            eyebrow="关于品牌"
            title={brand.slogan}
            desc={brand.intro}
          />
          <div className="mt-6 grid grid-cols-2 gap-4">
            <div className="p-4 rounded-lg bg-background-50 border border-background-200">
              <p className="font-heading text-xl text-primary-600">{brand.founded}</p>
              <p className="mt-1 text-xs text-foreground-600">开始整理每日热点话题</p>
            </div>
            <div className="p-4 rounded-lg bg-background-50 border border-background-200">
              <p className="font-heading text-xl text-secondary-700">1,286 条</p>
              <p className="mt-1 text-xs text-foreground-600">累计更新并整理的话题</p>
            </div>
          </div>
          <Link
            to="/about"
            className="mt-6 inline-flex items-center gap-1.5 text-sm text-primary-600 hover:text-primary-700 whitespace-nowrap"
          >
            了解我们的内容原则
            <i className="ri-arrow-right-line"></i>
          </Link>
        </div>
      </div>

      <div className="mt-14">
        <h3 className="font-heading text-xl md:text-2xl text-foreground-950 mb-6">用户在说什么</h3>
        <div className="grid grid-cols-1 md:grid-cols-3 gap-5">
          {testimonials.map((item) => (
            <blockquote
              key={item.id}
              className="bg-background-50 border border-background-200 rounded-lg p-5 md:p-6 flex flex-col"
            >
              <div className="flex items-center gap-1 text-accent-500 mb-3">
                {Array.from({ length: 5 }).map((_, i) => (
                  <i key={i} className="ri-star-fill text-sm"></i>
                ))}
              </div>
              <p className="text-sm text-foreground-700 leading-relaxed flex-1">“{item.text}”</p>
              <footer className="mt-4 flex items-center gap-3 pt-4 border-t border-background-200">
                <span className="w-9 h-9 flex items-center justify-center rounded-full bg-secondary-100 text-secondary-900 text-sm">
                  {item.name.slice(0, 1)}
                </span>
                <span>
                  <span className="block text-sm text-foreground-900">{item.name}</span>
                  <span className="block text-xs text-foreground-500">{item.role}</span>
                </span>
              </footer>
            </blockquote>
          ))}
        </div>
      </div>
    </section>
  );
}